import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

export interface DeleteConversationsTRPCInput {
  Ids: string[];
}

export const useDeleteConversationsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.conversation.deleteMany.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.comment.commentsByConversationId.queryKey(),
        });
      },
    }),
  });

  return {
    deleteConversations: async (
      input: DeleteConversationsTRPCInput
    ): Promise<{ affected_rows: number }> => mutation.mutateAsync(input),
    loading: mutation.isPending,
    error: mutation.error,
  };
};
